import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { debounceTime } from 'rxjs/operators';
import { Address } from '../../../../src/app/modules/domain/models';
import { SearchData } from './search-data';

@Component({
    selector: 'app-map-search-popup',
    templateUrl: './search-popup.component.html',
    styleUrls: ['./search-popup.component.scss']
})
export class SearchPopupComponent implements OnInit {
    @Input() addresses: Address[];
    @Output() filterAddresses: EventEmitter<SearchData> = new EventEmitter<SearchData>();
    @Output() zoomToFeature: EventEmitter<string> = new EventEmitter<string>();
    @Output() closePopup: EventEmitter<void> = new EventEmitter<void>();
    private searchData: SearchData;
    public streetSearch: FormControl;
    public numberSearch: FormControl;
    public citySearch: FormControl;
    public postalSearch: FormControl;

    ngOnInit(): void {
        this.searchData = new SearchData({
            street: undefined,
            number: undefined,
            city: undefined,
            postcode: undefined,
        });
        this.streetSearch = new FormControl(null);
        this.numberSearch = new FormControl(null);
        this.citySearch = new FormControl(null);
        this.postalSearch = new FormControl(null);

        this.streetSearch.valueChanges
            .pipe(debounceTime(250))
            .subscribe((searchInput: string) => {
                this.searchData.street = searchInput;
                return this.filterAddresses.emit(this.searchData);
            });
        this.numberSearch.valueChanges
            .pipe(debounceTime(250))
            .subscribe((searchInput: string) => {
                this.searchData.number = searchInput;
                return this.filterAddresses.emit(this.searchData);
            });
        this.citySearch.valueChanges
            .pipe(debounceTime(250))
            .subscribe((searchInput: string) => {
                this.searchData.city = searchInput;
                return this.filterAddresses.emit(this.searchData);
            });
        this.postalSearch.valueChanges
            .pipe(debounceTime(250))
            .subscribe((searchInput: string) => {
                this.searchData.postcode = searchInput;
                return this.filterAddresses.emit(this.searchData);
            });
    }
    showAddresses(): boolean {
        return this.addresses && this.addresses.length !== 0 && this.addresses.length < 100;
    }

    addressNotFound(): boolean {
        return this.addresses && this.addresses.length === 0
            && (this.searchData.street !== undefined || this.searchData.city !== undefined || this.searchData.number !== undefined || this.searchData.postcode !== undefined);
    }
    zoomToAddress(id: string): void {
        this.resetSearchData();
        this.zoomToFeature.emit(id);
    }
    onClosePopup(): void {
        this.resetSearchData();
        this.closePopup.emit();
    }
    resetStreet(): void {
        this.streetSearch.reset();
    }
    resetNumber(): void {
        this.numberSearch.reset();
    }
    resetCity(): void {
        this.citySearch.reset();
    }
    resetPostal(): void {
        this.postalSearch.reset();
    }
    resetSearchData(): void {
        this.searchData.street = undefined;
        this.searchData.number = undefined;
        this.searchData.city = undefined;
        this.searchData.postcode = undefined;
    }
}



// WEBPACK FOOTER //
// ./libs/map/components/search-popup/search-popup.component.ts